import * as React from 'react';
import { useRouter } from 'next/router';
import Layout from '../../../../layouts';
import Page from '../../../../components/Page';
import { PATH_DASHBOARD } from '../../../../routes/paths';
import ModalPolitica from '../../../../components/gps/ModalPolitica';

/* ============================================================================
   Casca da rota antiga do formulario de politica.

   O formulario virou MODAL (components/gps/ModalPolitica) e passou a ser aberto
   direto da lista. Esta rota continua existindo porque:

     - link e favorito antigos apontam para ca (`/politicas-novo/new/<name>`), e o
       menu ⋮ da lista tambem oferece "Duplicar", que monta
       `/politicas-novo/new/0?copiarDe=<origem>`;
     - e o caminho de entrada quando alguem manda a URL de uma politica para outra
       pessoa - abrir o sistema e ter de procurar a politica na lista seria perder o
       que o link ja diz.

   Aqui nao ha estado nem logica: le os parametros da rota, abre o modal e, ao
   fechar, devolve para a lista. O `aberto` e sempre `true` de proposito - fechar o
   modal nesta rota significa sair dela.
   ============================================================================ */

PaginaPolitica.getLayout = function getLayout(page: React.ReactElement) {
  return <Layout>{page}</Layout>;
};

export default function PaginaPolitica() {
  const { query, push, replace } = useRouter();

  const name = (query.name as string) || '';
  const copiarDe = (query.copiarDe as string) || '';

  return (
    <Page title="Políticas">
      <ModalPolitica
        aberto
        nome={name}
        copiarDe={copiarDe}
        onFechar={() => push(PATH_DASHBOARD.politicasNovo.root)}
        onSalvo={(salvo) => {
          // Ao CRIAR (ou duplicar), a URL ainda diz `0`. Trocar para o `name` que o
          // backend gerou faz o F5 reabrir a politica salva em vez de um formulario
          // vazio. `replace` e nao `push`: o `0` nao deve voltar no botao Voltar do
          // navegador, porque ele nao existe mais.
          if (salvo && (!name || name === '0')) {
            replace(PATH_DASHBOARD.politicasNovo.edit(encodeURIComponent(salvo)));
          }
        }}
      />
    </Page>
  );
}
